import React, { useState, useEffect, useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../../services/apiService';
import { AiOutlinePrinter } from 'react-icons/ai';
import { FaRegEye } from 'react-icons/fa6';
import moment from 'moment';
import { IoAddSharp } from 'react-icons/io5';
import { GrEdit } from 'react-icons/gr';
import { RiDeleteBin2Fill } from 'react-icons/ri';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import Pagination from '../../pagination/pagination';
import Select from 'react-select';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from 'react-spinners';

const GRNGrid = () => {
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  let navigate = useNavigate();
  const [pageSize, setPageSize] = useState(20);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pagination, setPagination] = useState();
  const [selectedtem, setSelectedItem] = useState(null);
  const apiService = new ApiService();
  const [searchLoader, setLoader] = useState(false);
  const gridRef = useRef();
  const [permissions, setPermissions] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [suppliers, setSupplier] = useState([]);
  useEffect(() => {
    fetchData()
    getItems();
  }, []);
  useEffect(() => {
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    const permissions = storedPermissions?.filter((acc) => acc.formName === 'GRN');
    setPermissions(permissions[0]);
  }, []);
  const handleEdit = () => {
    if (selectedRow?.status === 1 || selectedRow?.status === 5) {
      let eye = true;
      const updatedData = { ...selectedRow, eye: eye };
      navigate(`/Inventory/GRN/Update/${selectedRow.grnNo}`, { state: updatedData });
    } else {
      navigate(`/Inventory/GRN/Update/${selectedRow.grnNo}`, { state: selectedRow });
    }
  };
  const onGridReady = (params) => {
    gridRef.current = params.api;
    params.api.showLoadingOverlay();
  };
  const canEdit = selectedtem && (selectedtem?.status === 0 || selectedtem?.status === 2);
  const isPendingGrn = selectedRow?.status === 0;
  const canDelete = selectedRow && isPendingGrn;
  const [form, setForm] = useState({
    reqNo: "",
    poNo: "",
    vendorName: "",
    status: [{ label: 'All', value: 'All' }],
  });
  const StatusFilter = [
    { value: '', label: 'All' },
    { value: '0', label: 'Pending' },
    { value: '1', label: 'Approved' },
    { value: '5', label: 'Hold' },
    { value: '2', label: 'Rejected' },
  ];
  const fetchData = async (newPageNo = pagination?.currentPage) => {
    try {
      const response = await apiService.get('GET_SUPPLIER');
      setSupplier(response?.data?.result);
    } catch (error) {
      console.error("Error fetching stock data:", error);
    }
  };
  const handleDeleteClick = () => {
    if (canDelete) {
      setShowDeleteModal(true);
    }
  };
  const handleDeleteClose = () => {
    if (!deleting) {
      setShowDeleteModal(false);
    }
  };
  const handleDelete = async () => {
    if (!selectedRow?.grnNo) {
      return;
    }
    try {
      setDeleting(true);
      const grnNo = selectedRow.grnNo;
      const detailsRes = await apiService.getApiParamater('GET_GRN_MASTER_DETAILS', `?GRNNo=${grnNo}`);
      const grnDetails = detailsRes?.data?.result || [];

      for (const detail of grnDetails) {
        if (!detail?.grnDetailId) {
          continue;
        }
        const detailRes = await apiService.delete('DELETE_GRN_DETAILS', {
          data: { grnDetailId: detail.grnDetailId },
        });
        if (detailRes?.data?.statusCode !== 200 && detailRes?.data?.statusCode !== 204) {
          toast.warning(detailRes?.data?.message || `Unable to delete GRN detail ${detail.grnDetailId}`);
          return;
        }
      }

      const res = await apiService.delete('DELETE_GRN', { data: { grnNo } });
      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 204) {
        toast.success(res?.data?.message || `${grnNo} deleted successfully`);
        setShowDeleteModal(false);
        setSelectedRow(null);
        setSelectedItem(null);
        getItems();
      } else {
        toast.warning(res?.data?.message || 'Unable to delete GRN');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Error deleting GRN');
    } finally {
      setDeleting(false);
    }
  };
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      setLoader(true)
      gridRef.current?.showLoadingOverlay();
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('Id', form?.reqNo || '');
      params.append('POrderNo', form?.poNo || '');
      params.append('Status', form?.status?.value || '');
      params.append('InvoiceNo', form?.vendorName?.value?.supplier_ID || '');
      params.append('TransportMode', 'From PO');
      const res = await apiService.getApiParamater('GET_GRN', `?${params.toString()}`);
      setPagination(res.data.paginationData);
      const reversedData = res?.data?.result;
      const grnData = reversedData?.filter((dep) => dep.grnNo !== dep?.pOrderNo);
      setRowData(grnData || []);
      setLoading(false);
      setLoader(false)
      gridRef.current?.hideOverlay();
    } catch (error) {
      console.error('Error fetching items:', error);
      setLoading(false);
      setLoader(false)
      gridRef.current?.hideOverlay();
    }
  };
  const handlePrint = () => {
    if (selectedRow) {
      const token = localStorage.getItem('Token');
      const DB = localStorage.getItem('DataBase');
      if (!token) {
        alert('Auth token is missing! Unable to proceed.');
        return;
      }
      const popupWidth = 1000;
      const popupHeight = 600;
      const popupLeft = (window.screen.width - popupWidth) / 2;
      const popupTop = (window.screen.height - popupHeight) / 2;
      const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

      if (popup) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = REPORT_URL;
        form.target = 'ReportPopup';

        const inputs = [
          { name: 'authToken', value: token },
          { name: '_db', value: DB },
          { name: 'reportName', value: 'GRN' },
          { name: 'voucherNo', value: selectedRow?.grnNo },
        ];

        inputs.forEach(({ name, value }) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
      // navigate(`/Inventory/GRN/${selectedRow?.grnNo}`, { state: selectedRow })
    }
  };
  const handleEye = (clickedRowData) => {
    if (clickedRowData?.grnNo) {
      let eye = true;
      const updatedData = { ...clickedRowData, eye: eye };
      navigate(`/Inventory/GRN/Listing/${updatedData?.grnNo}`, { state: updatedData });
    } else if (selectedRow) {
      let eye = true;
      const updatedData = { ...selectedRow, eye: eye };
      navigate(`/Inventory/GRN/Listing/${updatedData?.grnNo}`, { state: updatedData });
    }
  };
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
  };
  const dateFormatter = (params) => {
    if (!params.value) return '';
    const date = moment(params.value);
    return date.isValid() ? date.format('DD-MMM-YYYY') : '';
  };
  const columnDefs = [
    { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
    { headerName: 'GRN No', field: 'grnNo', suppressMovable: true, width: 180 },
    { headerName: 'PO No', field: 'pOrderNo', suppressMovable: true, width: 180 },
    {
      headerName: 'Delivery Date',
      field: 'delivery_Date',
      suppressMovable: true,
      width: 150,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    {
      headerName: 'Invoice Date',
      field: 'invoiceDate',
      suppressMovable: true,
      width: 150,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    { headerName: 'Supplier ID', field: 'vendorId', suppressMovable: true, width: 150 },
    { headerName: 'Supplier Name', field: 'vendorName', suppressMovable: true, width: 200 },
    { headerName: 'Remarks', field: 'remarks', suppressMovable: true, width: 200 },
    {
      headerName: 'Status',
      field: 'status',
      suppressMovable: true,
      width: 140,
      cellRenderer: function (params) {
        if (params.value === 0 || params.value === null) {
          return <button class="btn pend ">Pending</button>;
        } else if (params.value === 1 || params.value === null) {
          return <button class="btn aproved">Approved</button>;
        } else if (params.value === 5 || params.value === null) {
          return <button class="btn hold">Hold</button>;
        } else if (params.value === 2 || params.value === null) {
          return <button class="btn reject">Rejected</button>;
        } else if (params.value === 3 || params.value === null) {
          return <button class="btn aproved">Approved</button>;
        } else {
          return params.value;
        }
      },
    },
    {
      headerName: 'Approval date',
      field: 'approvalDate',
      suppressMovable: true,
      width: 150,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    {
      headerName: 'Created date',
      field: 'modifiedOn',
      suppressMovable: true,
      width: 150,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    { headerName: 'Created By', field: 'modifiedBy', suppressMovable: true, width: 200 },
  ];
  const onCellClicked = (event) => {
    if (event.colDef.field === 'grnNo') {
      const clickedRowData = event.data;
      setSelectedRow(clickedRowData);
      handleEye(clickedRowData);
    }
  };
  const onSelectionChanged = async (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    const params = new URLSearchParams();
    params.append('DocNo', selectedRows[0]?.grnNo);
    params.append('DocumentType', 'GRN');
    try {
      const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
      const statuses = res?.data?.result?.map((item) => item.status);
      const allAreZero = statuses.every((status) => status === 0);
      const anyIsFive = statuses.some((status) => status === 2);
      if (allAreZero || anyIsFive) {
        setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
      } else {
        console.warn('No valid status to set the item.');
        setSelectedItem(null);
      }
    } catch (error) {
      setSelectedItem(null);
      console.error('Error fetching document status:', error);
    }
  };
  const handlenew = () => {
    navigate('/Inventory/GRN/Create');
  };

  const handleClearFilters = () => {
    const clearedFormData = {
      reqNo: "",
      poNo: "",
      vendorName: "",
      status: [{ label: 'All', value: 'All' }],
    };
    setForm(clearedFormData);
    getItems(1, clearedFormData);
  };
  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handlelocChange = (selectedOption) => {
    setForm({ ...form, status: selectedOption });
  };
  const handleSupplierChange = (selectedOption) => {
    setForm({ ...form, vendorName: selectedOption });
  };
  return (
    <div className="p-4">
      <div className='gridBg justify-content-between d-flex align-items-center' style={{ borderRadius: "16px 16px 0px 0px" }}>
        <h4 className="mainInvHead">GRN List</h4>
        <div className="d-flex justify-content-end gap-1">
          <div
            onClick={handleEye}
            className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
            style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
          >
            <FaRegEye color="#fff" className="center mt-1" />
            <div className="center">View</div>
          </div>
          {permissions?.canUpdate === true ? (
            <div
              onClick={canEdit ? handleEdit : null}
              className={`mainbtnSecondary flex-end gap-2 ${canEdit ? '' : 'disabled'}`}
              style={{
                cursor: canEdit ? 'pointer' : 'not-allowed',
              }}
            >
              <GrEdit color="#fff" className="center mt-1 " />
              <div className="center">Edit</div>
            </div>
          ) : (
            ''
          )}
          {permissions?.canUpdate === true ? (
            <div
              onClick={canDelete ? handleDeleteClick : null}
              className={`mainbtnRed flex-end gap-2 ${canDelete ? '' : 'disabled'}`}
              style={{
                cursor: canDelete ? 'pointer' : 'not-allowed',
              }}
            >
              <RiDeleteBin2Fill color="#fff" className="center mt-1" />
              <div className="center">Delete</div>
            </div>
          ) : (
            ''
          )}
          <div
            onClick={handlePrint}
            className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
            style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
          >
            <AiOutlinePrinter color="#fff" className="center mt-1 mx-2" />
            <div className="center">Print</div>
          </div>
          {permissions?.canAdd === true ? (
            <div className="col center">
              <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                <IoAddSharp color="#fff" className="center mt-1" /> <div>Add</div>
              </button>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="p-4 border-box2 ">
        <div className='row d-flex justify-content-between'>
          <div className='col d-flex justify-content-between'>
            <label htmlFor="PropertyGroup" className="form-label  pt-2 start">GRN No</label>
            <input
              type='text'
              className="form-Input w-100"
              value={form.reqNo}
              name="reqNo"
              onChange={handleInputChange}
            />
          </div>
          <div className='col d-flex justify-content-between'>
            <label htmlFor="PropertyGroup" className="form-label  pt-2 start">POrder No</label>
            <input
              type='text'
              className="form-Input w-100"
              value={form.poNo}
              name="poNo"
              onChange={handleInputChange}
            />
          </div>
          <div className='col-3'>
            {searchLoader === true ?
              <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
              <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                <div className='center'>Search</div>
              </div>
            }
          </div>
        </div>
        <div className='row d-flex justify-content-between mt-3'>
          <div className='col d-flex justify-content-between'>
            <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Status</label>
            <Select
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 2,
                height: 25,
                minHeight: 25
              })}
              className="w-100 p-0"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={form?.status}
              onChange={(selectedOption) => handlelocChange(selectedOption)}
              options={StatusFilter}
            />
          </div>
          <div className='col d-flex justify-content-between'>
            <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Vendor Name</label>
            <Select
              value={form?.vendorName}
              className="w-100 p-0"
              options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
              onChange={(selectedOption) => handleSupplierChange(selectedOption)}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
            />
          </div>
          <div className='col-3  '>
            <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
              <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
              <div className='center'>Reset</div>
            </div>
          </div>
        </div>
      </div>
      <div className="gridshad " style={{ height: '600px' }}>
        <div className="ag-theme-quartz" style={{ height: '600px' }}>
          <AgGridReact
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { background: '#F0EDF5' };
              } else {
                return { background: '#fff' };
              }
            }}
            rowData={rowData}
            enableFilter={true}
            floatingFilter={true}
            rowSelection={'single'}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            onCellClicked={onCellClicked}
            onSelectionChanged={onSelectionChanged}
          />
        </div>
        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
      </div>
      <Modal show={showDeleteModal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete GRN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete GRN <strong>{selectedRow?.grnNo}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteClose} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete} disabled={deleting}>
            {deleting ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default GRNGrid;
